export default __webpack_public_path__ + "static/media/photo--lg--misc-22.619afa3c.jpg";